customElements.get("dbtfy-addtocart-sticky") ||
  customElements.define(
    "dbtfy-addtocart-sticky",
    class extends HTMLElement {
      constructor() {
        super();

        this.testMode = Shopify.designMode;
        this.selectEvent = null;
        this.deselectEvent = null;
        this.toast = null;

        this.variantSelector = this.querySelector('select[name="id"]');

        this.mainVariantInput = document.querySelector(
          '.product .product-form input[name="id"], .product product-form input[name="id"]'
        );

        this.triggerType = this.dataset.triggerType;
        this.scrollDepth = parseInt(this.dataset.scrollDepth, 10) || 0;
        this.hasOnlyDefaultVariant =
          this.dataset.hasOnlyDefaultVariant === "true";
        this.position = this.dataset.position;
        this.colorScheme = this.dataset.colorScheme;
        this.showon = this.dataset.showon;
        this.CustomColorScheme = this.dataset.customColorScheme;
        this.addtocartSimplified = this.dataset.addtocartSimplified;

        this.variantSelector?.addEventListener("change", event => {
          this.onVariantChange(event);
        });

        this.mainVariantInput?.addEventListener("change", event => {
          this.onMainProductFormVariantChange(event);
        });

        this.backToTop = document.querySelector("back-to-top");
        this.whatsAppChat = document.querySelector("dbtfy-whatsapp-chat");

        this.handleScroll = null;
      }

      connectedCallback() {
        if (this.testMode) {
          this.selectEvent = subscribe(
            PUB_SUB_EVENTS.stickyAddToCartSelect,
            () => this.show()
          );

          this.deselectEvent = subscribe(
            PUB_SUB_EVENTS.stickyAddToCartDeselect,
            () => this.toast?.hideToast()
          );
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        if (this.testMode) {
          this.toast?.destroyToast();
          this.selectEvent?.();
          this.deselectEvent?.();
        }

        if (this.handleScroll) {
          window.removeEventListener("scroll", this.handleScroll);
        }
      }

      show() {
        let className = `dbtfy-addtocart-sticky show-on--${this.showon}`;

        if (this.position === "top") {
          className += " dbtfy-addtocart-sticky-top";
        }

        if (window.innerWidth < 750) {
          if (this.addtocartSimplified === "true") {
            className += " dbtfy-addtocart-simplified";

            if (this.backToTop) {
              this.backToTop.style.setProperty(
                "--dbtfy-btt-bottom-margin",
                "10rem"
              );

              this.whatsAppChat?.style.setProperty(
                "--scroll-whatsapp-height",
                "16rem"
              );
            } else {
              this.whatsAppChat?.style.setProperty(
                "--scroll-whatsapp-height",
                "10rem"
              );
            }
          } else if (this.backToTop) {
            this.backToTop.style.setProperty(
              "--dbtfy-btt-bottom-margin",
              "15rem"
            );

            this.whatsAppChat?.style.setProperty(
              "--scroll-whatsapp-height",
              "21rem"
            );
          } else {
            this.whatsAppChat?.style.setProperty(
              "--scroll-whatsapp-height",
              "15rem"
            );
          }
        } else if (this.backToTop && this.whatsAppChat) {
          this.whatsAppChat.style.setProperty(
            "--scroll-whatsapp-height",
            "8rem"
          );
        }

        const options = {
          position: `${this.position}-center`,
          maxWidth: "100%",
          className,
          colorScheme: this.colorScheme,
          customColorScheme: this.CustomColorScheme
        };

        this.toast = new Debutify.toast(this.innerHTML, options);
        this.onMainProductFormVariantChange();
      }

      init() {
        const scrollableHeight =
          document.body.scrollHeight - window.innerHeight;

        const triggerDepth =
          (this.scrollDepth / 100) * scrollableHeight;

        this.handleScroll = () => {
          const productForm = document.querySelector(
            ".product product-form, .product .product-form"
          );

          if (!productForm) {
            return;
          }

          const formBottom =
            productForm.getBoundingClientRect().bottom;

          const scrollPosition = window.scrollY;

          const shouldShow =
            (this.triggerType === "scroll" && formBottom < 0) ||
            (this.triggerType === "scroll_depth" &&
              scrollPosition >= triggerDepth);

          if (shouldShow) {
            if (!this.toast) {
              this.show();
            }
          } else {
            this.toast?.destroyToast();
            this.toast = null;
          }
        };

        window.addEventListener("scroll", this.handleScroll, {
          passive: true
        });

        this.handleScroll();
      }

      onVariantChange(event) {
        event.preventDefault();

        const selectedOption =
          this.variantSelector?.options[
            this.variantSelector.selectedIndex
          ];

        const variantImage = selectedOption?.dataset.variantImg;

        if (!variantImage) {
          return;
        }

        const image = this.querySelector(
          ".dbtfy-addtocart-sticky-img"
        );

        if (image) {
          image.src = variantImage;
        }
      }

      onMainProductFormVariantChange() {
        if (!this.toast || !this.mainVariantInput) {
          return;
        }

        const variantSelect =
          this.toast.toastContainer.querySelector(
            'select[name="id"]'
          );

        if (!variantSelect) {
          return;
        }

        variantSelect.value = this.mainVariantInput.value;
        variantSelect.dispatchEvent(new Event("change"));
      }
    }
  );